import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createSlots as _createSlots, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4839a638"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"color":"red","font-size":"14px"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_4 = {
  key: 4,
  style: {"font-size":"13px","font-weight":"bold"}
}
const _hoisted_5 = { style: {"margin-left":"5px"} }
const _hoisted_6 = { style: {"margin-left":"5px"} }
const _hoisted_7 = {
  key: 6,
  class: "surcharge-group-header"
}
const _hoisted_8 = { style: {"color":"#606266"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { style: {"white-space":"break-spaces","word-break":"break-all","word-wrap":"break-word"} }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 7 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-text" }, "暂无数据", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px 0px 20px 20px"} }, "关闭后该客户将无法查看相关服务", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_price_table_catalogue = _resolveComponent("price-table-catalogue")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_price_voyage_choose = _resolveComponent("price-voyage-choose")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_dynamic_search = _resolveComponent("miezz-dynamic-search")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_price_form = _resolveComponent("price-form")!
  const _component_miezz_history = _resolveComponent("miezz-history")!
  const _component_price_formula = _resolveComponent("price-formula")!
  const _component_price_batch_edit = _resolveComponent("price-batch-edit")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_price_calc = _resolveComponent("price-calc")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "price-table-catalogue",
      style: _normalizeStyle(`
    display: ${
      _ctx.disabledCatalogues ? 'none' : _ctx._toggle ? 'block' : 'none'
    }; top: ${
      _ctx.fixTop
        ? _ctx.fixTop
        : _ctx.search
        ? '98px'
        : _ctx.serviceId || _ctx.list.Dto?.SurchargeGroupId
        ? '30px'
        : '0'
    }`)
    }, [
      _createVNode(_component_price_table_catalogue, {
        ref: "ref-price-table-catalogue",
        serviceId: _ctx.serviceId,
        amountType: _ctx.amountType,
        onHandleInit: _ctx.handleInitCatalogues,
        onHandleChoose: _ctx.handleGetCatalogues
      }, null, 8, ["serviceId", "amountType", "onHandleInit", "onHandleChoose"])
    ], 4),
    _createElementVNode("div", {
      class: "price-list",
      style: _normalizeStyle(`
    left: ${_ctx.disabledCatalogues ? '0px' : _ctx._toggle ? '252px' : '12px'}; top: ${
      _ctx.fixTop
        ? _ctx.fixTop
        : _ctx.search
        ? '98px'
        : _ctx.serviceId || _ctx.list.Dto?.SurchargeGroupId
        ? '30px'
        : '0'
    }`)
    }, [
      _createElementVNode("div", {
        class: "toggle",
        style: _normalizeStyle(`${_ctx.disabledCatalogues ? 'display: none' : ''}`)
      }, [
        _createVNode(_component_miezz_button, {
          model: _ctx.toggleBtn,
          onHandleClick: _ctx.handleTopButtonClick
        }, null, 8, ["model", "onHandleClick"])
      ], 4),
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createBlock(_component_miezz_page_list, {
          ref: "ref-miezz-page-list",
          modelValue: _ctx.list,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.list) = $event)),
          onHandleGet: _ctx.handleGet,
          onHandleTopButtonClick: _ctx.handleTopButtonClick,
          onHandleTopButtonUpload: _ctx.handleTopButtonUpload,
          onHandleRowButtonClick: _ctx.handleRowButtonClick,
          onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
          onHandleBracketsBuild: _ctx.handleBracketsBuild,
          onHandleBracketsChange: _ctx.handleBracketsChange,
          onHandleDynamicSearch: _ctx.handleDynamicSearch
        }, _createSlots({
          "dynamic-search-customize": _withCtx(({ model }) => [
            (
              model.Where.Prop ==
              _ctx.list.DynamicSearchItems?.firstOrDefault(
                (it) => it.FieldCode == 'Voyage'
              )?.Prop
            )
              ? (_openBlock(), _createBlock(_component_price_voyage_choose, {
                  key: 0,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  onHandleChoose: _ctx.handleVoyageChoose
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleChoose"]))
              : (
              model.Where.Prop ==
              _ctx.list.DynamicSearchItems?.firstOrDefault(
                (it) => it.FieldCode == 'SailingDate'
              )?.Prop
            )
                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 1,
                    modelValue: model.Where.Value,
                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                    type: "date",
                    format: "YYYY/MM/DD",
                    "value-format": "YYYY/MM/DD",
                    class: "form-item-date"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : (
              model.Where.Prop ==
              _ctx.list.DynamicSearchItems?.firstOrDefault(
                (it) => it.FieldCode == 'Id'
              )?.Prop
            )
                  ? (_openBlock(), _createBlock(_component_miezz_input, {
                      key: 2,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock(_component_miezz_select, {
                      key: 3,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                      options: _ctx.searchs[model.Where.Prop],
                      remote: true,
                      remoteMethod: (q) => _ctx.querySearch(model.Where.Prop, q),
                      onFocus: ($event: any) => (_ctx.querySearch(model.Where.Prop, ''))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "remoteMethod", "onFocus"]))
          ]),
          column: _withCtx(({ model, row }) => [
            (model.Prop == 'Color')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createVNode(_component_miezz_button, {
                    model: {
                Code: 'mark',
                Type: 'color',
                Disabled: !(
                  (_ctx.amountType == _ctx.EnumPriceAmountType.Benchmark &&
                    !_ctx.serviceTableId &&
                    !_ctx.surcharge) ||
                  _ctx.amountType == _ctx.EnumPriceAmountType.Cost
                ),
              },
                    color: row.Color,
                    onHandleClick: 
                (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
              
                  }, null, 8, ["model", "color", "onHandleClick"])
                ]))
              : _createCommentVNode("", true),
            (model.Prop == 'AmountCustomize')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(row.AmountCustomize), 1))
              : (model.Prop == 'SettlementAmountCustomize')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    style: _normalizeStyle(`${
              row.Amount != undefined &&
              row.SettlementAmount != undefined &&
              row.SettlementAmount < row.Amount
                ? 'color: red'
                : ''
            }`)
                  }, [
                    (
                !_ctx.search &&
                row.SettlementLockAmount != undefined &&
                _ctx.amountType == _ctx.EnumPriceAmountType.Settlement
              )
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 0,
                          class: "icon-lock"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Lock)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(row.SettlementAmountCustomize), 1)
                  ], 4))
                : (model.Prop == 'GuideAmountCustomize')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      style: _normalizeStyle(`${
              row.Amount != undefined &&
              row.GuideAmount != undefined &&
              row.GuideAmount < row.Amount
                ? 'color: red'
                : ''
            }`)
                    }, [
                      (
                !_ctx.search &&
                row.GuideLockAmount != undefined &&
                _ctx.amountType == _ctx.EnumPriceAmountType.Guide
              )
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            class: "icon-lock"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Lock)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(row.GuideAmountCustomize), 1)
                    ], 4))
                  : (model.Prop == 'AgreementAmountCustomize')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 4,
                        style: _normalizeStyle(`${
              row.Amount != undefined &&
              row.AgreementAmount != undefined &&
              row.AgreementAmount < row.Amount
                ? 'color: red'
                : ''
            }`)
                      }, [
                        (
                !_ctx.search &&
                row.AgreementLockAmount != undefined &&
                _ctx.amountType == _ctx.EnumPriceAmountType.Agreement
              )
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              class: "icon-lock"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Lock)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(row.AgreementAmountCustomize), 1)
                      ], 4))
                    : (model.FieldCode == 'Link')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 5,
                          href: "javascript:void",
                          class: _normalizeClass(`field-link ${
              row.FieldValues.any(
                (it) => it.Column.Id == model.Prop && (it.LinkLabel || it.Link)
              )
                ? ''
                : 'empty'
            }`),
                          onClick: ($event: any) => (_ctx.handleLinkClick(row))
                        }, _toDisplayString(row.FieldValues.firstOrDefault((it) => it.Column.Id == model.Prop)
                ?.LinkLabel ??
              row.FieldValues.firstOrDefault((it) => it.Column.Id == model.Prop)
                ?.Link ??
              "暂无数据"), 11, _hoisted_12))
                      : (model.FieldCode == 'Remark')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            (
                row.FieldValues.any(
                  (it) => it.Column.Id == model.Prop && it.Label
                )
              )
                              ? (_openBlock(), _createBlock(_component_el_popover, {
                                  key: 0,
                                  placement: "top-start",
                                  "popper-class": "popover-tooltip",
                                  effect: "dark",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createVNode(_component_miezz_text_ellipsis, {
                                      text: 
                    row.FieldValues.firstOrDefault(
                      (it) => it.Column.Id == model.Prop
                    )?.Label
                  
                                    }, null, 8, ["text"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(row.FieldValues.firstOrDefault(
                    (it) => it.Column.Id == model.Prop
                  )?.Label), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, "--"))
                          ]))
                        : (model.Prop == 'Description')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              (row.Description)
                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                    key: 0,
                                    placement: "top-start",
                                    "popper-class": "popover-tooltip",
                                    effect: "dark",
                                    trigger: "hover"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createVNode(_component_miezz_text_ellipsis, {
                                        text: row.Description
                                      }, null, 8, ["text"])
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.Descriptions, (item, i) => {
                                        return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(item), 1))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createElementBlock("span", _hoisted_17, "--"))
                            ]))
                          : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (
            !_ctx._toggle || (_ctx.serviceId && !_ctx.search && !_ctx.list.Dto?.DynamicSearchId)
          )
            ? {
                name: "left-search",
                fn: _withCtx(() => [
                  (!_ctx._toggle)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.list.Data?.TableName), 1))
                    : _createCommentVNode("", true),
                  (_ctx.serviceId && !_ctx.search && !_ctx.list.Dto?.DynamicSearchId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, " 请先添加搜索条件 "))
                    : _createCommentVNode("", true)
                ]),
                key: "0"
              }
            : undefined,
          (!_ctx.serviceId)
            ? {
                name: "right-search",
                fn: _withCtx(() => [
                  (
              !_ctx.surcharge &&
              !_ctx.search &&
              (_ctx.amountType == _ctx.EnumPriceAmountType.Cost ||
                _ctx.amountType == _ctx.EnumPriceAmountType.Agreement) &&
              _ctx.list.Dto &&
              _ctx.list.Dto.CompanyId
            )
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: 
              _ctx.amountType == _ctx.EnumPriceAmountType.Cost
                ? '供应商'
                : _ctx.amountType == _ctx.EnumPriceAmountType.Agreement
                ? '客户企业'
                : ''
            ,
                        style: {"display":"inline-flex","margin-bottom":"0px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.list.Dto.CompanyId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list.Dto.CompanyId) = $event)),
                            options: _ctx.companies,
                            clearable: false,
                            labelKey: "Name",
                            valueKey: "Id",
                            markKey: "Mark",
                            style: {"width":"300px"},
                            onChange: _ctx.handleCompanyIdOrUserIdChanged
                          }, null, 8, ["modelValue", "options", "onChange"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : (_ctx.amountType == _ctx.EnumPriceAmountType.Cost)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "请先添加供应商"))
                      : _createCommentVNode("", true),
                  (_ctx.amountType == _ctx.EnumPriceAmountType.Agreement && _ctx.companyId)
                    ? (_openBlock(), _createBlock(_component_miezz_button, {
                        key: 2,
                        model: _ctx.btnServiceCompanyShow,
                        onHandleClick: _ctx.handleTopButtonClick
                      }, null, 8, ["model", "onHandleClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.amountType == _ctx.EnumPriceAmountType.Cost && _ctx.companyId)
                    ? (_openBlock(), _createBlock(_component_miezz_button, {
                        key: 3,
                        model: _ctx.btnSupplierFileShow,
                        onHandleClick: _ctx.handleTopButtonClick,
                        class: _normalizeClass(
              (_ctx.formSupplierFile.Data?.Files?.length ?? 0) > 0
                ? 'btnSupplierFileHas'
                : 'btnSupplierFileEmpty'
            )
                      }, null, 8, ["model", "onHandleClick", "class"]))
                    : _createCommentVNode("", true),
                  (_ctx.amountType == _ctx.EnumPriceAmountType.Agreement && _ctx.company)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, " 关联业务员：" + _toDisplayString(_ctx.company.Salesman
                  ? _ctx.company.Salesman.Name +
                    "/" +
                    _ctx.company.Salesman.User?.PhoneNumber
                  : "暂无数据"), 1),
                        _createElementVNode("span", _hoisted_6, " 关联客服：" + _toDisplayString(_ctx.company.CustomerService
                  ? _ctx.company.CustomerService.Name +
                    "/" +
                    _ctx.company.CustomerService.User?.PhoneNumber
                  : "暂无数据"), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
              _ctx.amountType == _ctx.EnumPriceAmountType.Settlement &&
              _ctx.list.Dto &&
              _ctx.list.Dto.UserId
            )
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 5,
                        label: "业务员",
                        style: {"display":"inline-flex","margin-bottom":"0px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.list.Dto.UserId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.list.Dto.UserId) = $event)),
                            options: _ctx.users,
                            markKey: "Data.Mark",
                            clearable: false,
                            style: {"width":"300px"},
                            onChange: _ctx.handleCompanyIdOrUserIdChanged
                          }, null, 8, ["modelValue", "options", "onChange"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.showSurchargeGroupId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, "ID：" + _toDisplayString(_ctx.list.Data?.SurchargeGroupId), 1),
                        (!_ctx.list.Data?.SurchargeGroupRemark)
                          ? (_openBlock(), _createBlock(_component_miezz_button, {
                              key: 0,
                              model: _ctx.btnAddSurchargeGroupRemark,
                              onHandleClick: _ctx.handleTopButtonClick
                            }, null, 8, ["model", "onHandleClick"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("span", null, "/" + _toDisplayString(_ctx.list.Data?.SurchargeGroupRemark), 1),
                              _createVNode(_component_miezz_button, {
                                model: _ctx.btnEditSurchargeGroupRemark,
                                onHandleClick: _ctx.handleTopButtonClick
                              }, null, 8, ["model", "onHandleClick"]),
                              _createVNode(_component_miezz_button, {
                                model: _ctx.btnDeleteSurchargeGroupRemark,
                                onHandleClick: _ctx.handleTopButtonClick
                              }, null, 8, ["model", "onHandleClick"])
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                key: "1"
              }
            : undefined
        ]), 1032, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleTopButtonUpload", "onHandleRowButtonClick", "onHandleBottomButtonClick", "onHandleBracketsBuild", "onHandleBracketsChange", "onHandleDynamicSearch"])), [
          [_directive_loading, _ctx.loading]
        ]),
        (_ctx.list.BottomButtons.any((it) => it.Code == 'add-calc'))
          ? (_openBlock(), _createBlock(_component_el_badge, {
              key: 0,
              value: _ctx.calcIds.length,
              hidden: _ctx.calcIds.length == 0,
              class: "calc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_button, {
                  model: _ctx.calcBtn,
                  onHandleClick: _ctx.handleTopButtonClick
                }, null, 8, ["model", "onHandleClick"])
              ]),
              _: 1
            }, 8, ["value", "hidden"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.serviceId && _ctx.catalogues.length == 0)
        ? (_openBlock(), _createBlock(_component_miezz_card, {
            key: 0,
            fix: true
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSearch,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalSearch) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.list.Dto)
          ? (_openBlock(), _createBlock(_component_miezz_dynamic_search, {
              key: 0,
              ref: "miezz-dynamic-search",
              modelValue: _ctx.list.Dto.DynamicSearchId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.list.Dto.DynamicSearchId) = $event)),
              modal: _ctx.modalSearch,
              "onUpdate:modal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalSearch) = $event)),
              items: _ctx.list.DynamicSearchItems,
              histories: _ctx.list.DynamicSearchHistory,
              code: _ctx.list.PowerCode,
              simple: _ctx.list.SimpleDynamicSearch,
              onHandleSearch: _ctx.handleDynamicSearch,
              onHandleBracketsBuild: _ctx.handleBracketsBuild,
              onHandleBracketsChange: _ctx.handleBracketsChange,
              onHandleGetHistories: _ctx.handleGetHistories
            }, {
              "dynamic-search-customize": _withCtx(({ model }) => [
                (
            model.Where.Prop ==
            _ctx.listItems.firstOrDefault((it) => it.FieldCode == 'Voyage')?.Prop
          )
                  ? (_openBlock(), _createBlock(_component_price_voyage_choose, {
                      key: 0,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (
            model.Where.Prop ==
            _ctx.listItems.firstOrDefault((it) => it.FieldCode == 'SailingDate')
              ?.Prop
          )
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 1,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        type: "date",
                        format: "YYYY/MM/DD",
                        "value-format": "YYYY/MM/DD",
                        class: "form-item-date"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 2,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.searchs[model.Where.Prop],
                        remote: true,
                        remoteMethod: (q) => _ctx.querySearch(model.Where.Prop, q),
                        onFocus: ($event: any) => (_ctx.querySearch(model.Where.Prop, ''))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "remoteMethod", "onFocus"]))
              ]),
              _: 1
            }, 8, ["modelValue", "modal", "items", "histories", "code", "simple", "onHandleSearch", "onHandleBracketsBuild", "onHandleBracketsChange", "onHandleGetHistories"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalForm,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalForm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_price_form, {
          modelValue: _ctx.modalForm,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalForm) = $event)),
          amountType: _ctx.amountType,
          tableId: _ctx.tableId,
          supplierId: _ctx.list.Dto?.CompanyId,
          id: _ctx.id,
          onHandleSubmit: _ctx.handleSubmit
        }, null, 8, ["modelValue", "amountType", "tableId", "supplierId", "id", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalHistory,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalHistory) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_history, {
          modelValue: _ctx.histories,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.histories) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalFormula,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalFormula) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_price_formula, {
          modelValue: _ctx.modalFormula,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalFormula) = $event)),
          importFromCost: _ctx.importFromCost,
          tableId: _ctx.tableId,
          amountType: _ctx.amountType,
          companyId: _ctx.list.Dto?.CompanyId,
          userId: _ctx.list.Dto?.UserId,
          rows: _ctx.formulaRows,
          formula: _ctx.formula,
          priceName: _ctx.list.Data?.TableName,
          search: _ctx.showFormulaSearch,
          alreadySearch: _ctx.alreadySearchFormula,
          onHandleSubmit: _ctx.handleSubmit,
          onHandleSearch: _ctx.handleSearchFormula
        }, null, 8, ["modelValue", "importFromCost", "tableId", "amountType", "companyId", "userId", "rows", "formula", "priceName", "search", "alreadySearch", "onHandleSubmit", "onHandleSearch"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBatchEdit,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBatchEdit) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_price_batch_edit, {
          modelValue: _ctx.modalBatchEdit,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalBatchEdit) = $event)),
          amountType: _ctx.amountType,
          companyId: _ctx.list.Dto?.CompanyId,
          userId: _ctx.list.Dto?.UserId,
          table: _ctx.list,
          onHandleSubmit: _ctx.handleSubmit
        }, null, 8, ["modelValue", "amountType", "companyId", "userId", "table", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalImportLog,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalImportLog) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importLogs, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "log-item",
            key: i
          }, [
            _createVNode(_component_el_alert, {
              title: item.Message,
              type: item.Type,
              effect: item.Effect,
              closable: false
            }, null, 8, ["title", "type", "effect"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSync,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalSync) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "sync-form",
          model: _ctx.modalSyncForm,
          rules: _ctx.modalSyncFormRule,
          "label-width": "150px",
          inline: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "Ids" }, {
              label: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.modalSyncForm.CheckAll,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalSyncForm.CheckAll) = $event)),
                  indeterminate: _ctx.modalSyncForm.CheckAllIndeterminate,
                  onChange: _ctx.handleSyncCheckAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全部 ")
                  ]),
                  _: 1
                }, 8, ["modelValue", "indeterminate", "onChange"])
              ]),
              default: _withCtx(() => [
                (_ctx.amountType == _ctx.EnumPriceAmountType.Settlement)
                  ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                      key: 0,
                      modelValue: _ctx.modalSyncForm.Ids,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalSyncForm.Ids) = $event)),
                      onChange: _ctx.handleSyncCheck
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users?.filter((it) => it.Value != _ctx.list.Dto?.UserId), (item) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: item.Value,
                            label: item.Value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.Label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.amountType == _ctx.EnumPriceAmountType.Agreement)
                  ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                      key: 1,
                      modelValue: _ctx.modalSyncForm.Ids,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalSyncForm.Ids) = $event)),
                      onChange: _ctx.handleSyncCheck
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies?.filter(
              (it) => it.Id != _ctx.list.Dto?.CompanyId
            ), (item) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: item.Id,
                            label: item.Id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.NameZh), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalServiceCompanyShow,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modalServiceCompanyShow) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_19,
        _createVNode(_component_miezz_page_list, {
          modelValue: _ctx.listServiceCompanyShow,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.listServiceCompanyShow) = $event))
        }, {
          column: _withCtx(({ model, row }) => [
            (model.Prop == 'Name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("a", {
                    style: {"text-decoration":"none"},
                    href: `#/price/setup/service/detail/${row.Id}/cost-composition`,
                    target: "_blank"
                  }, _toDisplayString(row.Name), 9, _hoisted_21)
                ]))
              : (model.Prop == 'Show')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_el_switch, {
                      modelValue: row.Show,
                      "onUpdate:modelValue": ($event: any) => ((row.Show) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAddSurchargeGroupById,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalAddSurchargeGroupById) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          style: {"margin-top":"10px"},
          ref: "ref-form-add-surcharge-group-by-id",
          model: _ctx.modalAddSurchargeGroupByIdData,
          rules: _ctx.modalAddSurchargeGroupByIdRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "ID",
              prop: "Id",
              "label-width": "38px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.modalAddSurchargeGroupByIdData.Id,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalAddSurchargeGroupByIdData.Id) = $event)),
                  options: _ctx.surchargeGroups,
                  placeholder: "请填入您要添加的附加费的ID"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCalc,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.modalCalc) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_price_calc, {
          modelValue: _ctx.modalCalc,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.modalCalc) = $event)),
          amountType: _ctx.amountType,
          companyId: _ctx.list.Dto?.CompanyId,
          salesmanId: _ctx.list.Dto?.SalesmanId ?? _ctx.list.Dto?.UserId,
          serviceId: _ctx.serviceId,
          ids: _ctx.calcIds,
          save: !_ctx.search,
          onHandleClear: _ctx.handleClearSelect,
          onHandleSubmit: _ctx.handleSubmit
        }, null, 8, ["modelValue", "amountType", "companyId", "salesmanId", "serviceId", "ids", "save", "onHandleClear", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSurchargeGroupRemark,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.modalSurchargeGroupRemark) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "form-surcharge-group-remark",
          modelValue: _ctx.formSurchargeGroupRemark,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formSurchargeGroupRemark) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSupplierFile,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.modalSupplierFile) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "form-supplier-file",
          modelValue: _ctx.formSupplierFile,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formSupplierFile) = $event))
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'Files')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_upload, {
                      modelValue: _ctx.formSupplierFile.Data.Files,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formSupplierFile.Data.Files) = $event)),
                      path: "price/file",
                      prop: "File",
                      maxSize: 2 * 1024 * 1024
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}